import * as Yup from 'yup';
import { PersonRole } from '../../models/eums/personRole';

export const validationSchema = Yup.object().shape({
  emailAddress: Yup.string().email('email_value_error').required('email_value_required'),
  userRole: Yup.string().trim().oneOf(Object.values(PersonRole)).required('user_role_required'),
});
